export default "__VITE_ASSET__CJZlVkja__"